<template>
  <v-card outlined class="mx-auto">
    <template>
      <v-card-subtitle
        class="font-weight-bold"
      >
        <div class="d-flex flex-column flex-sm-row justify-space-between align-sm-center">
          <div class="d-flex align-center mb-2 mb-sm-0">
            {{
              $vuetify.lang.t("$vuetify.questionnaire.questionnaire_logs_title")
            }}
            &nbsp;
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <v-icon small v-on="on" v-bind="attrs">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>
                {{
                  $vuetify.lang.t(
                    "$vuetify.questionnaire.questionnaire_logs_title"
                  )
                }}
              </span>
            </v-tooltip>
          </div>
          <div class="d-flex flex-row align-center mt-2 mt-sm-0">
            <v-btn
              class="mr-1"
              color="primary"
              @click="questionnaireLogFileGenerationModal = true"
              small
              :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
            >
              <span class="v-btn__content">
                <v-icon left small>mdi-download</v-icon>
                {{ $vuetify.lang.t("$vuetify.common.csv") }}
              </span>
            </v-btn>
            <v-btn
              class="ml-1"
              small
              color="primary"
              @click="questionnaireLogHistoryModal = true"
              :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
            >
              <v-icon left>mdi-history</v-icon>
              <span class="hidden-sm-and-down">
                {{ $vuetify.lang.t("$vuetify.common.history") }}
              </span>
            </v-btn>
          </div>
        </div>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-row class="d-flex flex-column flex-md-row py-4 mb-n6 px-6">
        <v-col width class="pa-0 pr-0 pr-md-3">
          <v-text-field
            v-model="questionnaireFilter"
            :label="
              $vuetify.lang.t('$vuetify.questionnaire.search_questionnaire_id')
            "
            outlined
            dense
            clearable
          ></v-text-field>
        </v-col>
        <v-col width class="pa-0 pr-0 pr-md-3">
          <v-text-field
            v-model="userFilter"
            :label="$vuetify.lang.t('$vuetify.questionnaire.search_user_id')"
            outlined
            dense
            clearable
          ></v-text-field>
        </v-col>
        <v-col class="pa-0 pr-0 pr-md-3">
          <v-text-field
            v-model="searchFilter"
            :label="$vuetify.lang.t('$vuetify.questionnaire.search_prompt')"
            outlined
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-data-table
        :headers="questionnairesLogsHeaders"
        :items="questionnaires_logs"
        :loading="isLoading"
        :loading-text="$vuetify.lang.t('$vuetify.common.loading_text')"
        :server-items-length="totalHits"
        :items-per-page="itemsPerPage"
        :page="page"
        @update:page="page = $event"
        @update:items-per-page="itemsPerPage = $event"
        :footer-props="{ showFirstLastPage: true }"
      >
        <template v-slot:item.questionnaire_id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{
                  item.questionnaire_id
                    ? item.questionnaire_id.split("-")[0]
                    : ""
                }}
              </span>
            </template>
            <span>{{ item.questionnaire_id || "N/A" }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.user_id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ item.user_id ? item.user_id.split("-")[0] : "" }}
              </span>
            </template>
            <span>{{ item.user_id || "N/A" }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.member_id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ item.member_id ? item.member_id.split("-")[0] : "" }}
              </span>
            </template>
            <span>{{ item.member_id || "N/A" }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.request_id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ item.request_id ? item.request_id.split("-")[0] : "" }}
              </span>
            </template>
            <span>{{ item.request_id || "N/A" }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:item.prompt="{ item }">
          {{ truncatedPrompt(item) }}
        </template>
        <template v-slot:item.response="{ item }">
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="mr-1"
                  @click="detail_response_modal(item)"
                >mdi-eye</v-icon>
              </template>
              <span>{{ $vuetify.lang.t("$vuetify.common.details") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <template v-if="detailModal">
        <v-dialog v-model="detailModal">
          <v-card>
            <v-card-title>
              <span class="headline font-weight-bold">
                {{
                  $vuetify.lang.t(
                    "$vuetify.questionnaire.questionnaire_response_title"
                  )
                }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-list-item-title class="text-h6">
                {{ $vuetify.lang.t("$vuetify.questionnaire.survey_values") }}
              </v-list-item-title>
              <v-row class="ml-0">
                <v-col
                  cols="12"
                  v-if="
                    !Object.keys(detailResponseModalData.survey_values || {})
                      .length
                  "
                >
                  <span>N/A</span>
                </v-col>
                <v-col
                  v-else
                  v-for="(
                    value, key
                  ) in detailResponseModalData.survey_values || {}"
                  :key="key"
                  cols="12"
                >
                  <v-expansion-panels accordion>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        key
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col
                            v-for="(val, subkey) in value"
                            :key="subkey"
                            cols="12"
                          >
                            <v-row>
                              <v-col cols="6">
                                <span>{{ subkey }}</span>
                              </v-col>
                              <v-col cols="6">
                                <span>
                                  :
                                  {{
                                    Array.isArray(val)
                                      ? val.join(", ") || "N/A"
                                      : typeof val === "object" && val !== null
                                        ? Object.values(val).join(", ")
                                        : val || "N/A"
                                  }}
                                </span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-divider inset class="ma-0 pb-2"></v-divider>
              <template>
                <v-list-item-title class="text-h6">
                  {{ $vuetify.lang.t("$vuetify.questionnaire.excludes") }}
                </v-list-item-title>
                <v-container>
                  <v-chip-group active-class="primary--text" column>
                    <span
                      v-if="
                        !detailResponseModalData.excludes ||
                        detailResponseModalData.excludes.length === 0
                      "
                    >
                      N/A
                    </span>
                    <v-chip
                      v-else
                      v-for="(
                        exclude, index
                      ) in detailResponseModalData.excludes"
                      :key="index"
                    >
                      {{ exclude }}
                    </v-chip>
                  </v-chip-group>
                </v-container>
                <v-divider inset class="ma-0 pb-2"></v-divider>
              </template>
              <template>
                <v-list-item-title class="text-h6">
                  {{ $vuetify.lang.t("$vuetify.questionnaire.prompt") }}
                </v-list-item-title>
                <div class="pa-3">
                  <p class="mb-0">
                    {{ detailResponseModalData.prompt || "N/A" }}
                  </p>
                </div>
                <v-divider inset class="ma-0 pb-2"></v-divider>
              </template>

              <!-- ####################### -->

              <template>
                <v-row align="center" justify="space-between">
                  <v-col cols="6">
                    <v-list-item-title class="text-h6">
                      {{
                        $vuetify.lang.t("$vuetify.questionnaire.recommendation")
                      }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="3" class="d-flex justify-end">
                    <v-select
                      v-model="selectedKeys"
                      :items="availableKeys"
                      label="Select data keys"
                      multiple
                      chips
                      deletable-chips
                      clearable
                      @change="handleSelectChange"
                    ></v-select>
                  </v-col>
                </v-row>
              </template>
              <template>
                <v-row>
                  <v-col
                    v-for="(value, key) in detailResponseModalData.response
                      .detail.recommendations || {}"
                    :key="key"
                    cols="12"
                  >
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          {{ key }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row>
                            <v-col cols="12">
                              <v-expansion-panels accordion>
                                <v-expansion-panel
                                  v-for="(item, index) in value"
                                  :key="index"
                                >
                                  <v-expansion-panel-header>
                                    <span
                                      class="item_btn"
                                      @click.stop="openItemDetails(item)"
                                    >
                                      {{ item[itemIdName] }}
                                    </span>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <v-simple-table>
                                      <template v-slot:default>
                                        <tbody class="p-4">
                                          <tr
                                            v-for="key in selectedKeys"
                                            :key="key"
                                          >
                                            <div class="py-4">
                                              <td class="pr-4 font-weight-bold">
                                                {{ key }}:
                                              </td>
                                              <td
                                                v-html="
                                                  formatDetail(
                                                    item[itemIdName],
                                                    key,
                                                    true
                                                  )
                                                "
                                              ></td>
                                            </div>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </template>
              <template v-if="itemDetailsModal">
                <v-dialog
                  v-model="itemDetailsModal"
                  max-width="1000px"
                  persistent
                  scrollable
                  hide-overlay
                  transition="dialog-bottom-transition"
                  content-class="rounded-lg"
                  elevation="24"
                  rounded
                >
                  <Loader v-if="itemLoading" />
                  <v-card v-else class="rounded-lg" elevation="24" rounded>
                    <v-card-title>
                      <span class="headline">
                        <span
                          class="d-inline-block text-truncate"
                          style="max-width: 720px"
                        >
                          {{ selectedItemTitle }}
                        </span>
                      </span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <div v-for="(value, key) in selectedItem" :key="key">
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">
                            {{ key }}
                          </v-col>
                          <v-col cols="8">
                            <div v-html="formatDetail(value, key)"></div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                      <v-btn
                        text
                        color="error"
                        @click="itemDetailsModal = false"
                      >
                        {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>

              <!-- ######################## -->
            </v-card-text>
            <v-card-actions class="d-flex justify-end">
              <v-btn color="error" text @click="detailModal = false">
                {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template v-if="questionnaireLogFileGenerationModal">
        <FileGenerationModal
          :open="questionnaireLogFileGenerationModal"
          :closeModal="closeQuestionnaireLogFileGenerationModal"
          :title="
            $vuetify.lang.t(
              '$vuetify.logs_file_generation.questionnaire_logs_file_generation_title'
            )
          "
          :downloadRequestTxt="
            $vuetify.lang.t(
              '$vuetify.logs_file_generation.questionnaire_logs_download_request_txt'
            )
          "
          :fileGenerationInstructionTxt="
            $vuetify.lang.t(
              '$vuetify.logs_file_generation.generate_questionnaire_logs_instruction'
            )
          "
          :requestFileGeneration="questionnaireLogsDownloadRequest"
          :prefix="questionnaire_logs_prefix"
          :history_type="HISTORY_TYPES.QUESTIONNAIRE"
        />
      </template>
      <template v-if="questionnaireLogHistoryModal">
        <FileGeneratedHistoryModal
          :open="questionnaireLogHistoryModal"
          :closeModal="closeQuestionnaireLogHistoryModal"
          :title="
            $vuetify.lang.t(
              '$vuetify.logs_file_generation.questionnaire_logs_file_generated_history_title'
            )
          "
          :prefix="questionnaire_logs_prefix"
        />
      </template>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import {
  GET_QUESTIONNAIRE_LOG,
  GET_CATALOG_ITEMS,
  GET_MAPPER,
  GET_ITEMS_DETAILS_BY_IDS,
  GENERATE_QUESTIONNAIRE_LOGS,
} from "@/store/_actiontypes";
import FileGenerationModal from "@/components/common/FileGenerationModal";
import FileGeneratedHistoryModal from "@/components/common/FileGeneratedHistoryModal";
import { HISTORY_TYPES } from "@/global/_constants";
import Loader from "@/components/common/loader/Loader.vue";
export default {
  props: {
    startDate: {
      type: String,
      required: false,
    },
    endDate: {
      type: String,
      required: false,
    },
  },
  components: {
    Loader,
    FileGeneratedHistoryModal,
    FileGenerationModal,
  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      selectedProject: state => state.project.selectedProject,
    }),
    ...mapGetters("loader", ["loading"]),
    truncatedPrompt() {
      const MAX_PROMPT_LENGTH = 50;
      return item =>
        item?.prompt
          ? item.prompt.length > MAX_PROMPT_LENGTH
            ? item.prompt.substring(0, MAX_PROMPT_LENGTH) + "..."
            : item.prompt
          : "N/A";
    },
  },
  watch: {
    startDate(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
    endDate(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
    page(newVal) {
      this.getQuestionnaire();
    },
    itemsPerPage(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
    questionnaireFilter(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
    userFilter(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
    searchFilter(newVal) {
      this.page = 1;
      this.getQuestionnaire();
    },
  },
  mounted() {
    this.getQuestionnaire();
    this.getMapperFunction();
  },
  data() {
    return {
      isLoading: false,
      itemIdName: "",
      mapperData: {},
      questionnaires_logs: [],
      logs_data: [],
      selectedItem: {},
      catalogItems: [],
      allItemDetails: [],
      itemLoading: false,
      availableKeys: [],
      selectedKeys: [],
      panel: [],
      headers: [],
      tableData: [],
      selectedItemTitle: "",
      questionnaireFilter: "",
      userFilter: "",
      searchFilter: "",
      page: 1,
      itemsPerPage: 10,
      totalHits: 0,
      returnedHits: 0,
      HISTORY_TYPES: HISTORY_TYPES,
      questionnaireLogFileGenerationModal: false,
      questionnaireLogHistoryModal: false,
      questionnaire_logs_prefix: "questionnaire_logs_download",
      questionnairesLogsHeaders: [
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.questionnaire_id"),
          align: "start",
          sortable: false,
          value: "questionnaire_id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.user_id"),
          align: "start",
          sortable: false,
          value: "user_id",
        },
        {
          text: "Member ID",
          align: "start",
          sortable: false,
          value: "member_id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.request_id"),
          align: "start",
          sortable: false,
          value: "request_id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.created_at"),
          align: "start",
          sortable: false,
          value: "created_at",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.prompt"),
          align: "start",
          sortable: false,
          value: "prompt",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.questionnaire.response"),
          align: "start",
          sortable: false,
          value: "response",
        },
      ],
      detailModal: false,
      detailResponseModalData: {},
      itemDetailsModal: false,
      itemDetailsData: {},
    };
  },
  methods: {
    ...mapActions("questionnaire", [GET_QUESTIONNAIRE_LOG]),
    ...mapActions("project", [GENERATE_QUESTIONNAIRE_LOGS]),
    ...mapActions("project", [GET_CATALOG_ITEMS, GET_MAPPER]),
    ...mapActions("items", [GET_ITEMS_DETAILS_BY_IDS]),
    getQuestionnaire() {
      let params = {
        start: (this.page - 1) * this.itemsPerPage,
        size: this.itemsPerPage === -1 ? this.totalHits : this.itemsPerPage,
      };
      if (this.questionnaireFilter) {
        params.questionnaire_id = this.questionnaireFilter;
      }
      if (this.userFilter) {
        params.user_id = this.userFilter;
      }
      if (this.searchFilter) {
        params.search = this.searchFilter;
      }
      if (this.startDate) {
        params.start_date = this.startDate;
      }
      if (this.endDate) {
        params.end_date = this.endDate;
      }
      this.isLoading = true;
      this.GET_QUESTIONNAIRE_LOG({
        project_id: this.selectedProject.id,
        params,
      })
        .then(
          response => {
            this.questionnaires_logs =
              response.data?.logs?.recommendation_log || [];
            this.totalHits = response.data?.logs?.total_hits || 0;
            this.returnedHits = response.data?.logs?.returned_hits || 0;
          },
          error => {
            console.error("error", error);
          }
        )
        .finally(() => {
          this.isLoading = false;
        });
    },
    closeQuestionnaireLogHistoryModal() {
      this.questionnaireLogHistoryModal = false;
    },
    closeQuestionnaireLogFileGenerationModal() {
      this.questionnaireLogFileGenerationModal = false;
    },
    getMapperFunction() {
      this.GET_MAPPER({
        project_id: this.selectedProject.id,
      }).then(
        response => {
          const responseData = response.data.detail.response;
          this.mapperData = responseData;
          for (const key in responseData) {
            if (
              Object.prototype.hasOwnProperty.call(responseData, key) &&
              key === "item_id"
            ) {
              this.itemIdName = responseData[key];
            }
          }
          this.isLoading = false;
        },
        _error => {
          this.isLoading = false;
        }
      );
    },
    questionnaireLogsDownloadRequest({ project_id, start_date, end_date, language }) {
      return this.GENERATE_QUESTIONNAIRE_LOGS({
        project_id,
        start_date,
        end_date,
        language,
      });
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    detail_response_modal(item) {
      this.detailResponseModalData = item;
      const allItemList = Object.values(item.response.detail.recommendations)
        .flat()
        .map(product => product[this.itemIdName]);
      this.GET_ITEMS_DETAILS_BY_IDS({
        project_id: this.selectedProject.id,
        ids: allItemList,
      }).then(
        response => {
          this.allItemDetails = response.data.detail.response;
          this.getCatalogItems();
        },
        _error => {}
      );
      this.detailModal = true;
    },
    getItemDetail(itemId, key) {
      const itemDetail = this.allItemDetails.find(
        detail => detail[this.itemIdName] === itemId
      );
      return itemDetail ? itemDetail[key] : null;
    },
    getItemDetailsByID(item_id) {
      this.GET_ITEMS_DETAILS_BY_IDS({
        project_id: this.selectedProject.id,
        ids: [item_id],
      }).then(
        response => {
          const data = response.data.detail.response[0];
          this.selectedItem = data;
        },
        _error => {}
      );
    },
    openItemDetails(item) {
      this.selectedItemTitle = item[this.itemIdName];
      this.getItemDetailsByID(item[this.itemIdName]);
      this.itemDetailsModal = true;
    },
    getCatalogItems() {
      let project_id = this.selectedProject.id;
      const payload = {};
      this.GET_CATALOG_ITEMS({
        project_id: project_id,
        payload: payload,
      }).then(
        response => {
          this.catalogItems = response.data.detail.response.items.map(
            item => item.item
          );
          this.availableKeys = [
            ...new Set(
              this.catalogItems.flatMap(item =>
                Object.keys(item).filter(key => key !== this.itemIdName)
              )
            ),
          ];
          this.updateTableData();
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          console.error("Error fetching catalog items:", error);
        }
      );
    },
    updateTableData() {
      this.headers = [
        {
          text: this.itemIdName,
          value: this.itemIdName,
          sortable: false,
        },
        ...this.selectedKeys.map(key => ({
          text: key,
          value: key,
        })),
      ];
      this.tableData = this.catalogItems.map(item => {
        const rowData = {
          id: item[this.itemIdName],
          [this.itemIdName]: item[this.itemIdName],
        };
        this.selectedKeys.forEach(key => {
          rowData[key] = item[key] !== undefined ? item[key] : "N/A";
        });
        return rowData;
      });
    },
    handleSelectChange(item) {
      this.updateTableData();

      this.expandAllPanels();
    },
    expandAllPanels() {
      this.panel = this.tableData.map((_, index) => index);
    },
    formatDetail(itemIdOrValue, key = null, isItemId = false) {
      // If we are using itemId (indicating it's not directly passed as value)
      let value = isItemId
        ? this.getItemDetail(itemIdOrValue, key)
        : itemIdOrValue;

      // If it's an array, join it
      if (Array.isArray(value)) {
        return value.join(", ");
      }

      // If it's a string with commas, split and trim each item
      if (typeof value === "string" && value.includes(",")) {
        return value
          .split(",")
          .map(v => v.trim())
          .join(", ");
      }

      // If it looks like HTML (basic check), return as-is for v-html
      if (typeof value === "string" && /<[^>]+>/.test(value)) {
        return value;
      }

      // If it's an object, join its values
      if (typeof value === "object" && value !== null) {
        return Object.values(value).join(", ");
      }

      return value || "";
    },
  },
};
</script>

<style scoped>
.item_btn {
  cursor: pointer;
  font-weight: bold;
  color: #1f5592;
  padding: 5px;
}
@media (max-width: 959px) {
  ::v-deep .v-btn__content .v-icon--left {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
}
</style>
